import Vue from "vue"
import app from "./app.vue"
import router from "./router"

import "@/initializers/luxon.js"

import "bootstrap"
import "@/assets/css/screen.scss"

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(app)
}).$mount("#app")
